 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import XHTMLCOVER from '@/components/xhtml/cover'
 import XHTMLUNINCORPORATED_HALF1 from '@/components/xhtml/Unincorporated_half-1'
 import XHTMLUNINCORPORATED_ADCA1 from '@/components/xhtml/Unincorporated_adca-1'
 import XHTMLUNINCORPORATED_TITL1 from '@/components/xhtml/Unincorporated_titl-1'
 import XHTMLUNINCORPORATED_NOTICE from '@/components/xhtml/Unincorporated_notice'
 import XHTMLCONTENTS from '@/components/xhtml/contents'
 import XHTMLUNINCORPORATED_COPY from '@/components/xhtml/Unincorporated_copy'
 import XHTMLUNINCORPORATED_DEDI1 from '@/components/xhtml/Unincorporated_dedi-1'
 import XHTMLUNINCORPORATED_ACKN1 from '@/components/xhtml/Unincorporated_ackn-1'
 import XHTMLUNINCORPORATED_PART1 from '@/components/xhtml/Unincorporated_part-1'
 import XHTMLUNINCORPORATED_CHAP1 from '@/components/xhtml/Unincorporated_chap-1'
 import XHTMLUNINCORPORATED_CHAP2 from '@/components/xhtml/Unincorporated_chap-2'
 import XHTMLUNINCORPORATED_CHAP3 from '@/components/xhtml/Unincorporated_chap-3'
 import XHTMLUNINCORPORATED_CHAP4 from '@/components/xhtml/Unincorporated_chap-4'
 import XHTMLUNINCORPORATED_CHAP5 from '@/components/xhtml/Unincorporated_chap-5'
 import XHTMLUNINCORPORATED_CHAP6 from '@/components/xhtml/Unincorporated_chap-6'
 import XHTMLUNINCORPORATED_CHAP7 from '@/components/xhtml/Unincorporated_chap-7'
 import XHTMLUNINCORPORATED_CHAP8 from '@/components/xhtml/Unincorporated_chap-8'
 import XHTMLUNINCORPORATED_CHAP9 from '@/components/xhtml/Unincorporated_chap-9'
 import XHTMLUNINCORPORATED_CHAP10 from '@/components/xhtml/Unincorporated_chap-10'
 import XHTMLUNINCORPORATED_PART2 from '@/components/xhtml/Unincorporated_part-2'
 import XHTMLUNINCORPORATED_CHAP11 from '@/components/xhtml/Unincorporated_chap-11'
 import XHTMLUNINCORPORATED_CHAP12 from '@/components/xhtml/Unincorporated_chap-12'
 import XHTMLUNINCORPORATED_CHAP13 from '@/components/xhtml/Unincorporated_chap-13'
 import XHTMLUNINCORPORATED_CHAP14 from '@/components/xhtml/Unincorporated_chap-14'
 import XHTMLUNINCORPORATED_CHAP15 from '@/components/xhtml/Unincorporated_chap-15'
 import XHTMLUNINCORPORATED_APPE1 from '@/components/xhtml/Unincorporated_appe-1'
 import XHTMLUNINCORPORATED_APPE2 from '@/components/xhtml/Unincorporated_appe-2'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/xhtml/contents",
 			"name" : "xhtml/contents",
 			"component" : XHTMLCONTENTS
 		},
 		{
 			"path" : "/xhtml/Unincorporated_copy",
 			"name" : "xhtml/Unincorporated_copy",
 			"component" : XHTMLUNINCORPORATED_COPY
 		},
 		{
 			"path" : "/xhtml/Unincorporated_dedi-1",
 			"name" : "xhtml/Unincorporated_dedi-1",
 			"component" : XHTMLUNINCORPORATED_DEDI1
 		},
 		{
 			"path" : "/xhtml/Unincorporated_ackn-1",
 			"name" : "xhtml/Unincorporated_ackn-1",
 			"component" : XHTMLUNINCORPORATED_ACKN1
 		},
 		{
 			"path" : "/xhtml/Unincorporated_part-1",
 			"name" : "xhtml/Unincorporated_part-1",
 			"component" : XHTMLUNINCORPORATED_PART1
 		},
 		{
 			"path" : "/xhtml/Unincorporated_chap-1",
 			"name" : "xhtml/Unincorporated_chap-1",
 			"component" : XHTMLUNINCORPORATED_CHAP1
 		},
 		{
 			"path" : "/xhtml/Unincorporated_chap-2",
 			"name" : "xhtml/Unincorporated_chap-2",
 			"component" : XHTMLUNINCORPORATED_CHAP2
 		},
 		{
 			"path" : "/xhtml/Unincorporated_chap-3",
 			"name" : "xhtml/Unincorporated_chap-3",
 			"component" : XHTMLUNINCORPORATED_CHAP3
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js